import React, { useState, useEffect } from "react";
import styles from "assets/scss/task_management.module.css";
import "assets/scss/style.css";
import { Trans } from "react-i18next";
import { Table } from "reactstrap";
import Label from "./Label";
import { PayrollClient } from "services";
import { useOrganisationContext, useUserContext } from "hooks";
import { NotificationManager } from "react-notifications";
import AddLabel from "./AddLabel";
import { Page } from 'components/common';
import BackButton from 'components/refactoring/BackButton';

const Labels = ({ employees, t}) => {
    const [labels, setLabels] = useState(null);
    const [showLabelModal, setShowLabelModal] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");

    const client = PayrollClient();
    const { selectedOrganisation } = useOrganisationContext();
    const { user } = useUserContext();
    const userPermission = user?.permissions?.includes("hr_task_manager");

    useEffect(() => {
        fetchLabels();
}, [selectedOrganisation]);

    const fetchLabels = async () => {
        try {
            const response = await client.get(`/employee-bucket-task-label-management`);
            const data = response;
            setLabels(data.data);
        } catch (error) {
            console.error("Error fetching labels:", error);
        }
    };

    const handleUpdateLabel = async (label) => {
        try {
            await client.put(`/planner-bucket-task-label-management/${label.id}`, label);
            fetchLabels();
            NotificationManager.success("Label updated successfully");
        } catch (error) {
            console.error('Error updating label:', error);
            NotificationManager.error("Failed to Update label");
        }
    };

    const handleSaveLabel = async (group) => {
        try {
            await client.post(`/planner-bucket-task-label-management`, group);
            fetchLabels();
            NotificationManager.success("Label added successfully");
        } catch (error) {
            console.error('Error adding label:', error);
            NotificationManager.error("Failed to add label");
        }
    };

    const handleDeleteLabel = async (label) => {
        try {
            await client.delete(`/planner-bucket-task-label-management/${label.id}`);
            fetchLabels();
            NotificationManager.success("Label deleted successfully");
        } catch (error) {
            console.error('Error deleting label:', error);
            NotificationManager.error("Failed to delete label");
        }
    };

    const filteredLabels = labels?.filter(label =>
        (label?.label_name?.toLowerCase() || '').includes(searchQuery.toLowerCase())
    );

    return (

        <Page title={t("Labels")}>
          <BackButton/>
        <div className={styles.groupContainer}>
            <div className={styles.groupHeader}>
                <input 
                    className={styles.searchBar}
                    type="search"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    placeholder="Search..."
                />
                <button className={styles.addButton} onClick={() => setShowLabelModal(true)}>+ <Trans>Add New Label</Trans></button>
            </div>
        <Table size="sm" className="small" style={{border: '1px solid #e9ecef'}}>
          <thead>
            <tr>
              <th className="text-left"><Trans>Label Name</Trans></th>
              <th className="text-center"><Trans>Action</Trans></th>
              <th className="text-right" />
            </tr>
          </thead>

            {filteredLabels ? filteredLabels?.map((label, index) => (
              <Label
                key={index}
                label={label}
                handleUpdateLabel={handleUpdateLabel}
                handleDeleteLabel={handleDeleteLabel}
                employees={employees}
                selectedOrganisation={selectedOrganisation}
            />
            )):
            labels?.map((label, index) => (
                <Label
                    key={index}
                    label={label}
                    handleUpdateLabel={handleUpdateLabel}
                    handleDeleteLabel={handleDeleteLabel}
                    employees={employees}
                    selectedOrganisation={selectedOrganisation}
                />
            ))
            }
        </Table>
        {userPermission && (
                <AddLabel
                    isOpen={showLabelModal}
                    onClose={() => setShowLabelModal(false)}
                    onSave={handleSaveLabel}
                    employees={employees}
                    selectedOrganisation={selectedOrganisation}
                />
            )}
        </div>
        </Page>
    );
};

export default Labels;